import * as React from 'react';
import { useContext } from 'react';
import { Button } from '@cian/ui-kit';
import { MobilePhoneFetcher } from './MobilePhoneFetcher';
import { TPlaceType } from '../../types/promoOffersSelection/callButton';
import { getPhoneLink } from '../../utils/phone';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

interface IMobileCallButtonProps {
  placeType: TPlaceType;
  onClick(): void;
}

export const MobileCallButton = ({ placeType, onClick }: IMobileCallButtonProps) => {
  const { siteBlockId, builder } = useContext(PromoOfferCardContext);

  const linkPhone = React.useMemo(() => {
    if (!builder || builder.phones.length === 0) {
      return null;
    }

    return getPhoneLink(builder.phones[0]);
  }, [builder]);

  const [needFetchPhone, setNeedFetchPhone] = React.useState(false);

  const onCallClick = React.useCallback(() => {
    onClick();

    if (siteBlockId) {
      setNeedFetchPhone(true);

      return;
    }

    window.open(linkPhone as string, '_self');
  }, [linkPhone, onClick, siteBlockId]);

  /* istanbul ignore next */
  if (!linkPhone) {
    return null;
  }

  return (
    <>
      <Button onClick={onCallClick} size="M" theme="fill_primary" fullWidth tabIndex={-1}>
        Позвонить застройщику
      </Button>
      {needFetchPhone && <MobilePhoneFetcher placeType={placeType} />}
    </>
  );
};
